import React, { useEffect, useState } from 'react';
import { FaWhatsapp, FaUserFriends, FaLeaf, FaLock } from 'react-icons/fa';
import { FiClock, FiUsers, FiFileText, FiUser, FiPhone, FiMapPin, FiCalendar } from 'react-icons/fi';
import { BiLeaf } from 'react-icons/bi';
import { MdOutlineSetMeal, MdCookie } from 'react-icons/md';
import { BsSendFill } from 'react-icons/bs';
import Navbar from "../../Components/NavBar/index";
import Body7 from '../../Components/Home-new/Body7/index';
import Body9 from '../../Components/Home-new/Body9/index';
import Footer from '../../Components/Footer/index';
import { BulkOrderDataProvider, useBulkOrderData } from '../../database/BulkOrderDataContext';
import { BulkOrderSkeleton, Body7Skeleton, Body9Skeleton } from '../../Components/Skeletons/Skeletons';
import { useApi } from '../../context/ApiContext';
import SEO from '../../Components/SEO/index';
import FAQsComponent from '../../Components/FAQs/index';

const bulkOrderFaqsData = {
  mainHeading: "Bulk Order FAQs",
  faqs: [
    {
      question: "What is the minimum bulk order quantity?",
      answer: "We currently accept bulk orders starting from 10 people."
    },
    {
      question: "Can the menu be customized?",
      answer: "Yes, menus can be customized according to your event, food preferences and budget."
    },
    {
      question: "How early should I place a bulk order?",
      answer: "Larger orders may require advance preparation time. We recommend placing your request as early as possible for better planning and slot availability."
    },
    {
      question: "Do you provide vegetarian and non-vegetarian food?",
      answer: "Yes, we offer Veg, Non-Veg and Snacks options for bulk orders."
    },
    {
      question: "Do you deliver for office lunches and corporate events?",
      answer: "Yes, BentoBox caters to office lunches, team gatherings, meetings and corporate events."
    },
    {
      question: "Do you provide food for birthday parties and house gatherings?",
      answer: "Yes, we prepare fresh homemade meals for birthdays, celebrations, family gatherings and small events."
    },
    {
      question: "Are the meals freshly prepared?",
      answer: "All meals are freshly prepared using quality ingredients in trusted home kitchens."
    },
    {
      question: "How does pricing work for bulk orders?",
      answer: "Pricing depends on the number of people, menu selection and food preferences. Our team will share customized pricing after reviewing your requirements."
    },
    {
      question: "How will I receive confirmation after submitting the form?",
      answer: "Once you submit your request, our team will contact you shortly with menu options, pricing and delivery details."
    },
    {
      question: "Which locations do you serve?",
      answer: "We currently serve selected areas in Gurgaon and nearby locations depending on order size and availability."
    }
  ],
  contactBox: {
    heading: "Do you have more questions?",
    content: "Can't find what you're looking for? Our BentoBox customer support team is here to help!",
    button: "Shoot a direct mail",
    img: ""
  }
};

const BulkOrderContent = () => {
  const { data, isLoading } = useBulkOrderData();
  const { submitBulkOrder } = useApi();
  const [isSubmitting, setIsSubmitting] = useState(false);


  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: '',
    deliveryLocation: '',
    deliveryDate: '',
    preferredTime: '',
    people: '',
    foodType: [],
    budget: '',
    requirements: ''
  });

  const [errors, setErrors] = useState({});
  const [showTimeDropdown, setShowTimeDropdown] = useState(false);

  const getMinDate = () => {
    const { people } = formData;
    const now = new Date();

    if (!people) return now.toISOString().split('T')[0];

    let offsetHours = 0;
    if (people === '10-20') offsetHours = 2;
    else if (people === '20-50') offsetHours = 3;
    else if (people === '50-80') offsetHours = 6;
    else offsetHours = 24;

    if (offsetHours >= 24) {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow.toISOString().split('T')[0];
    }

    const latestSlotToday = new Date();
    latestSlotToday.setHours(22, 0, 0, 0);

    const minRequiredTime = new Date(now.getTime() + offsetHours * 60 * 60 * 1000);

    if (minRequiredTime > latestSlotToday) {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow.toISOString().split('T')[0];
    }

    return now.toISOString().split('T')[0];
  };

  const getAvailableTimeSlots = () => {
    const slots = [];
    const { deliveryDate, people } = formData;
    if (!deliveryDate || !people) return slots;

    const startHour = 9;
    const endHour = 22;

    let offsetHours = 0;
    if (people === '10-20') offsetHours = 2;
    else if (people === '20-50') offsetHours = 3;
    else if (people === '50-80') offsetHours = 6;
    else offsetHours = 24;

    const now = new Date();
    const selectedDate = new Date(deliveryDate);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);

    const isToday = selectedDate.getTime() === today.getTime();

    if (isToday && offsetHours >= 24) return slots;

    for (let h = startHour; h <= endHour; h++) {
      let isValid = true;
      if (isToday) {
        const slotTime = new Date(now);
        slotTime.setHours(h, 0, 0, 0);

        const minRequiredTime = new Date(now.getTime() + offsetHours * 60 * 60 * 1000);
        if (slotTime < minRequiredTime) {
          isValid = false;
        }
      }

      if (isValid) {
        const timeValue = `${h.toString().padStart(2, '0')}:00`;
        const ampm = h >= 12 ? 'PM' : 'AM';
        const displayH = h % 12 || 12;
        const displayString = `${displayH}:00 ${ampm}`;
        slots.push({ value: timeValue, label: displayString });
      }
    }
    return slots;
  };

  const handleFoodTypeToggle = (type) => {
    setFormData(prev => ({
      ...prev,
      foodType: prev.foodType.includes(type)
        ? prev.foodType.filter(t => t !== type)
        : [...prev.foodType, type]
    }));
    if (errors.foodType) {
      setErrors(prev => ({ ...prev, foodType: null }));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const newData = { ...prev, [name]: value };
      if (name === 'deliveryDate' || name === 'people') {
        newData.preferredTime = '';
      }
      return newData;
    });
    setErrors(prev => {
      const newErrors = { ...prev, [name]: null };
      if (name === 'deliveryDate') {
        newErrors.preferredTime = null;
      }
      return newErrors;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    const { fullName, phoneNumber, deliveryLocation, deliveryDate, preferredTime, people, foodType, budget, requirements } = formData;

    if (!fullName) newErrors.fullName = "Name is required";

    if (!phoneNumber) newErrors.phoneNumber = "Phone number is required";
    else if (!/^\d{10}$/.test(phoneNumber)) newErrors.phoneNumber = "Invalid phone number";

    if (!deliveryLocation) newErrors.deliveryLocation = "Delivery location is required";

    if (!deliveryDate) newErrors.deliveryDate = "Delivery date is required";
    else {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedD = new Date(deliveryDate);
      selectedD.setHours(0, 0, 0, 0);
      if (selectedD < today) {
        newErrors.deliveryDate = "Invalid delivery date selected";
      }
    }

    if (!preferredTime) newErrors.preferredTime = "Time slot is required";
    else if (deliveryDate && !newErrors.deliveryDate) {
      const availableSlots = getAvailableTimeSlots();
      const isValidSlot = availableSlots.some(slot => slot.value === preferredTime);
      if (!isValidSlot) {
        newErrors.preferredTime = "Selected slot is unavailable. Please choose a later slot.";
      }
    }

    if (!people || parseInt(people.split('-')[0].replace('+', '')) < 10) {
      newErrors.people = "Minimum bulk order quantity is 10 people";
    }

    if (foodType.length === 0) {
      newErrors.foodType = "Please select at least one food type";
    } else {
      const allowedFoodTypes = ['Veg', 'Non-Veg', 'Snacks'];
      if (foodType.some(type => !allowedFoodTypes.includes(type))) {
        newErrors.foodType = "Invalid food type selected";
      }
    }

    if (!budget) newErrors.budget = "Budget range is required";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    setIsSubmitting(true);
    try {
      const orderPayload = {
        name: fullName,
        phoneNumber,
        deliveryLocation,
        deliveryDate,
        deliverySlot: preferredTime,
        peopleRange: people,
        foodTypes: foodType,
        budgetRange: budget.replace(/₹/g, ''),
        additionalRequirements: requirements
      };

      console.log("Bulk Order Payload:", orderPayload);

      await submitBulkOrder(orderPayload);
      alert("Form submitted successfully!");
      setFormData({
        fullName: '',
        phoneNumber: '',
        deliveryLocation: '',
        deliveryDate: '',
        preferredTime: '',
        people: '',
        foodType: [],
        budget: '',
        requirements: ''
      });
    } catch (err) {
      alert("There was an error submitting your request. Please try again or contact us on WhatsApp.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) {
    return (
      <>
        <BulkOrderSkeleton />
        <Body7Skeleton />
        <Body9Skeleton />
      </>
    );
  }

  const bulkData = data?.bulkOrder || {
    headings: {},
    buttons: {},
    bottomHeadings: {},
    image: {}
  };

  const { headings, buttons, bottomHeadings, image } = bulkData;

  return (
    <>
      {/* Hero Section */}
      <section className="min-h-[100svh] w-full bg-[#FEF2F2] flex items-center justify-center relative overflow-hidden">
        {/* Background with image and gradient */}
        <div className="absolute inset-0 z-0 flex">
          <div className="absolute inset-0 bg-catering-gradient md:bg-[linear-gradient(105deg,#FFF6EF_0%,#FFF6EF_55%,transparent_65%)] z-10 w-full h-full pointer-events-none opacity-90 md:opacity-100"></div>
          <div className="w-full h-full md:w-full md:h-full ml-auto overflow-hidden absolute right-0 top-0">
            <img
              src={image.bgImg}
              alt="Delicious Indian catering food feast"
              className="w-full h-full object-cover object-right md:object-center opacity-40 md:opacity-100"
            />
          </div>
        </div>

        {/* Main Content Container */}
        <div className="container mx-auto px-6 md:px-12 lg:px-24 z-20 h-full flex flex-col justify-center pt-32 pb-10 md:py-20 relative">
          <div className="max-w-2xl w-full">

            {/* Badge */}
            <div className="animate-fade-in-up opacity-0" style={{ animationDelay: '100ms' }}>
              <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-amber-200/60 bg-[#FFF6EF]/80 backdrop-blur-sm text-[#B45309] text-xs font-bold tracking-wider uppercase shadow-sm">
                <FaUserFriends className="text-amber-600" /> {headings.h1}
              </span>
            </div>

            {/* Heading */}
            <h1 className="mt-4 md:mt-6 text-4xl sm:text-5xl md:text-6xl lg:text-[4.5rem] font-bold text-[#450A0A] leading-[1.1] font-serif animate-fade-in-up opacity-0" style={{ animationDelay: '200ms', fontFamily: '"Playfair Display SC", serif' }}>
              {headings.h2_normal}<br />
              <span className="text-[#D97706]">{headings.h2_orange}</span>
            </h1>

            {/* Description */}
            <p className="mt-4 md:mt-6 text-base sm:text-lg md:text-xl text-[#57534E] max-w-xl font-medium leading-relaxed animate-fade-in-up opacity-0" style={{ animationDelay: '300ms' }}>
              {headings.h3}
            </p>

            {/* Buttons */}
            <div className="mt-6 md:mt-8 flex flex-col sm:flex-row gap-3 md:gap-4 animate-fade-in-up opacity-0" style={{ animationDelay: '400ms' }}>
              <button
                onClick={() => {
                  document.getElementById('catering-form')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="flex items-center justify-center gap-2 bg-[#F97316] hover:bg-[#EA580C] text-white px-8 py-3.5 rounded-xl font-semibold transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-0.5 active:translate-y-0"
              >
                <FiFileText className="text-xl" /> {buttons.b1}
              </button>
              <button
                onClick={() => window.open('https://wa.me/919876095163?text=Hi%20BentoBox,%20I%20have%20an%20inquiry%20about%20a%20bulk%20order.', '_blank')}
                className="flex items-center justify-center gap-2 bg-white hover:bg-green-50 text-[#166534] border border-green-200 px-8 py-3.5 rounded-xl font-semibold transition-all duration-300 shadow-md hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0">
                <FaWhatsapp className="text-green-600 text-xl" /> {buttons.b2}
              </button>
            </div>

            {/* Features Bottom Row */}
            <div className="mt-8 sm:mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 animate-fade-in-up opacity-0" style={{ animationDelay: '500ms' }}>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full border border-amber-200 flex items-center justify-center text-amber-600 bg-white/50 backdrop-blur-sm">
                  <BiLeaf className="text-xl" />
                </div>
                <div className="text-sm font-semibold text-[#44403C] leading-tight">
                  {bottomHeadings.uh1} <br /> <span className="font-normal text-[#78716C]">{bottomHeadings.bh1}</span>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full border border-amber-200 flex items-center justify-center text-amber-600 bg-white/50 backdrop-blur-sm">
                  <FiClock className="text-xl" />
                </div>
                <div className="text-sm font-semibold text-[#44403C] leading-tight">
                  {bottomHeadings.uh2} <br /> <span className="font-normal text-[#78716C]">{bottomHeadings.bh2}</span>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full border border-amber-200 flex items-center justify-center text-amber-600 bg-white/50 backdrop-blur-sm">
                  <FiUsers className="text-xl" />
                </div>
                <div className="text-sm font-semibold text-[#44403C] leading-tight">
                  {bottomHeadings.uh3} <br /> <span className="font-normal text-[#78716C]">{bottomHeadings.bh3}</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Form Section */}
      <section id="catering-form" className="pt-12 pb-8 bg-[#FFF9F5] relative scroll-mt-8">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          <div className="flex justify-center">

            {/* Form Column */}
            <div className="w-full max-w-8xl">
              <div className="bg-white rounded-3xl p-8 md:p-10 shadow-xl border border-gray-100">
                <form onSubmit={handleSubmit} className="space-y-8">
                  {/* Section 1 */}
                  <div>
                    <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <span className="text-[#D97706]">1.</span> Your Details
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Full Name *</label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                            <FiUser />
                          </div>
                          <input
                            type="text"
                            name="fullName"
                            value={formData.fullName}
                            onChange={handleInputChange}
                            className={`block w-full pl-10 pr-3 py-3 border rounded-xl text-sm transition-colors ${errors.fullName ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-200 focus:ring-amber-500 focus:border-amber-500'}`}
                            placeholder="Enter your name"
                          />
                        </div>
                        {errors.fullName && <p className="text-red-500 text-[10px] mt-1 ml-1">{errors.fullName}</p>}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number *</label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                            <FiPhone />
                          </div>
                          <input
                            type="tel"
                            name="phoneNumber"
                            value={formData.phoneNumber}
                            onChange={handleInputChange}
                            className={`block w-full pl-10 pr-3 py-3 border rounded-xl text-sm transition-colors ${errors.phoneNumber ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-200 focus:ring-amber-500 focus:border-amber-500'}`}
                            placeholder="Enter 10 digit number"
                          />
                        </div>
                        {errors.phoneNumber && <p className="text-red-500 text-[10px] mt-1 ml-1">{errors.phoneNumber}</p>}
                      </div>
                    </div>
                  </div>

                  {/* Section 2 */}
                  <div className="pt-2 border-t border-gray-50">
                    <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <span className="text-[#D97706]">2.</span> Food Preferences
                    </h3>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-3">Number of People *</label>
                        <div className="grid grid-cols-3 gap-2">
                          {['10-20', '20-50', '50-80', '80-150', '150-200', '200+'].map(num => (
                            <button
                              key={num}
                              type="button"
                              onClick={() => {
                                setFormData(prev => ({ ...prev, people: num, preferredTime: '' }));
                                setErrors(prev => ({ ...prev, people: null, deliveryDate: null, preferredTime: null }));
                              }}
                              className={`py-2 text-xs font-medium rounded-lg border transition-all ${formData.people === num ? 'border-amber-500 bg-amber-50 text-amber-700' : 'border-gray-200 text-gray-600 hover:border-gray-300'}`}
                            >
                              {num}
                            </button>
                          ))}
                        </div>
                        {errors.people ? (
                          <p className="text-red-500 text-[10px] mt-2">{errors.people}</p>
                        ) : (
                          <p className="text-[10px] text-gray-400 mt-2">Minimum bulk order quantity is 10 people.</p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-3">Food Type *</label>
                        <div className="grid grid-cols-3 gap-2">
                          {[
                            { id: 'Veg', icon: <FaLeaf className={formData.foodType.includes('Veg') ? 'text-green-600' : 'text-green-500'} /> },
                            { id: 'Non-Veg', icon: <MdOutlineSetMeal className={formData.foodType.includes('Non-Veg') ? 'text-red-600' : 'text-red-500'} /> },
                            { id: 'Snacks', icon: <MdCookie className={formData.foodType.includes('Snacks') ? 'text-amber-600' : 'text-amber-500'} /> }
                          ].map(type => (
                            <button
                              key={type.id}
                              type="button"
                              onClick={() => handleFoodTypeToggle(type.id)}
                              className={`py-2 flex flex-col items-center gap-1 text-[10px] font-medium rounded-lg border transition-all ${formData.foodType.includes(type.id) ? 'border-amber-500 bg-amber-50 text-amber-700' : 'border-gray-200 text-gray-600 hover:border-gray-300'}`}
                            >
                              <span className="text-lg">{type.icon}</span>
                              {type.id}
                            </button>
                          ))}
                        </div>
                        {errors.foodType ? (
                          <p className="text-red-500 text-[10px] mt-2">{errors.foodType}</p>
                        ) : (
                          <p className="text-[10px] text-gray-400 mt-2">Select all that apply</p>
                        )}
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-3">Budget Per Person (₹) *</label>
                        <div className="grid grid-cols-2 gap-2">
                          {['₹99-149', '₹149-199', '₹199-299', '₹299+'].map(budget => (
                            <button
                              key={budget}
                              type="button"
                              onClick={() => setFormData(prev => ({ ...prev, budget: budget }))}
                              className={`py-2 text-xs font-medium rounded-lg border transition-all ${formData.budget === budget ? 'border-amber-500 bg-amber-50 text-amber-700' : 'border-gray-200 text-gray-600 hover:border-gray-300'}`}
                            >
                              {budget}
                            </button>
                          ))}
                        </div>
                        {errors.budget ? (
                          <p className="text-red-500 text-[10px] mt-2">{errors.budget}</p>
                        ) : (
                          <p className="text-[10px] text-gray-400 mt-2">Final menu and pricing will be customized according to your requirements.</p>
                        )}
                      </div>

                    </div>
                  </div>

                  {/* Section 3 */}
                  <div className="pt-2 border-t border-gray-50">
                    <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <span className="text-[#D97706]">3.</span> Event Details
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                      <div className="md:col-span-1 min-w-0">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Delivery Location *</label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                            <FiMapPin />
                          </div>
                          <input
                            type="text"
                            name="deliveryLocation"
                            value={formData.deliveryLocation}
                            onChange={handleInputChange}
                            className={`block w-full pl-10 pr-3 py-3 border rounded-xl text-sm transition-colors ${errors.deliveryLocation ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-200 focus:ring-amber-500 focus:border-amber-500'}`}
                            placeholder="Enter delivery location"
                          />
                        </div>
                        {errors.deliveryLocation && <p className="text-red-500 text-[10px] mt-1 ml-1">{errors.deliveryLocation}</p>}
                      </div>
                      <div className="md:col-span-1 min-w-0">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Delivery Date *</label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                            <FiCalendar />
                          </div>
                          <input
                            type="date"
                            name="deliveryDate"
                            value={formData.deliveryDate}
                            min={getMinDate()}
                            onChange={handleInputChange}
                            disabled={!formData.people}
                            className={`block w-full min-w-0 pl-10 pr-3 py-3 border rounded-xl text-sm transition-colors text-gray-500 disabled:bg-gray-100 disabled:cursor-not-allowed ${errors.deliveryDate ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-200 focus:ring-amber-500 focus:border-amber-500'}`}
                          />
                          {!formData.people && (
                            <div
                              className="absolute inset-0 cursor-not-allowed z-10"
                              onClick={() => setErrors(prev => ({ ...prev, deliveryDate: "Please select number of people first" }))}
                            ></div>
                          )}
                        </div>
                        {errors.deliveryDate ? (
                          <p className="text-red-500 text-[10px] mt-1 ml-1">{errors.deliveryDate}</p>
                        ) : (
                          <p className="text-[10px] text-gray-400 mt-2">{!formData.people && "Please select number of people first"}</p>
                        )}
                      </div>
                      <div className="md:col-span-1 min-w-0">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Preferred Time Slot *</label>
                        <div className="relative">
                          <div
                            className={`relative flex items-center w-full pl-10 pr-3 py-3 border rounded-xl text-sm transition-colors bg-white ${(!formData.people || !formData.deliveryDate) ? 'bg-gray-100 cursor-not-allowed text-gray-400 border-gray-200'
                                : (errors.preferredTime ? 'border-red-500 text-gray-700 cursor-pointer'
                                  : 'border-gray-200 hover:border-amber-400 text-gray-700 cursor-pointer')
                              }`}
                            onClick={() => {
                              if (!formData.people) {
                                setErrors(prev => ({ ...prev, preferredTime: "Please select number of people first" }));
                              } else if (!formData.deliveryDate) {
                                setErrors(prev => ({ ...prev, preferredTime: "Please select delivery date first" }));
                              } else {
                                setShowTimeDropdown(prev => !prev);
                              }
                            }}
                          >
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                              <FiClock />
                            </div>
                            <div className="flex-grow select-none">
                              {formData.preferredTime
                                ? getAvailableTimeSlots().find(s => s.value === formData.preferredTime)?.label || formData.preferredTime
                                : (!formData.people ? "Select people first" : (formData.deliveryDate ? "Select preferred time" : "Select date first"))}
                            </div>
                            <div className="flex items-center text-gray-400">
                              <svg className={`w-4 h-4 transition-transform duration-200 ${showTimeDropdown ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
                            </div>
                          </div>

                          {showTimeDropdown && formData.people && formData.deliveryDate && (
                            <>
                              <div className="fixed inset-0 z-20 bg-black/25 transition-opacity" onClick={() => setShowTimeDropdown(false)}></div>
                              <div className="absolute z-30 w-full mt-2 bg-white border border-gray-100 rounded-xl shadow-xl overflow-hidden animate-fade-in-up" style={{ animationDuration: '200ms' }}>
                                <ul className="max-h-48 overflow-y-auto [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-gray-200 [&::-webkit-scrollbar-thumb]:rounded-full hover:[&::-webkit-scrollbar-thumb]:bg-gray-300">
                                  {getAvailableTimeSlots().length > 0 ? (
                                    getAvailableTimeSlots().map(slot => (
                                      <li
                                        key={slot.value}
                                        className={`px-4 py-3 text-sm cursor-pointer transition-colors hover:bg-amber-50 ${formData.preferredTime === slot.value ? 'bg-amber-100 text-amber-900 font-semibold' : 'text-gray-700'}`}
                                        onClick={() => {
                                          setFormData(prev => ({ ...prev, preferredTime: slot.value }));
                                          setErrors(prev => ({ ...prev, preferredTime: null }));
                                          setShowTimeDropdown(false);
                                        }}
                                      >
                                        {slot.label}
                                      </li>
                                    ))
                                  ) : (
                                    <li className="px-4 py-3 text-sm text-gray-500 italic text-center">No slots available for this date.</li>
                                  )}
                                </ul>
                              </div>
                            </>
                          )}
                        </div>
                        {errors.preferredTime ? (
                          <p className="text-red-500 text-[10px] mt-2 ml-1">{errors.preferredTime}</p>
                        ) : (
                          <p className="text-[10px] text-gray-400 mt-2">Time slots depend on preparation time and order size.</p>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Section 4 */}
                  <div className="pt-2 border-t border-gray-50">
                    <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <span className="text-[#D97706]">4.</span> Additional Requirements
                    </h3>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Tell us more about your event, food preferences, special requests, etc.</label>
                    <div className="relative">
                      <textarea
                        name="requirements"
                        value={formData.requirements}
                        onChange={handleInputChange}
                        rows="4"
                        maxLength="500"
                        className="block w-full p-4 border border-gray-200 rounded-xl focus:ring-amber-500 focus:border-amber-500 text-sm transition-colors resize-none"
                        placeholder="Write your additional requirements here..."
                      ></textarea>
                      <div className="absolute bottom-3 right-3 text-xs text-gray-400">
                        {formData.requirements.length}/500
                      </div>
                    </div>
                  </div>

                  {/* Actions */}
                  <div className="pt-4 flex flex-col gap-3">
                    <button type="submit" disabled={isSubmitting} className="w-full bg-[#E85D04] hover:bg-[#D00000] text-white py-4 rounded-xl font-bold transition-colors flex items-center justify-center gap-2 text-lg shadow-md disabled:opacity-70 disabled:cursor-not-allowed">
                      <BsSendFill /> {isSubmitting ? 'Submitting...' : 'Get Custom Quote'}
                    </button>
                    <button
                      type="button"
                      onClick={() => window.open('https://wa.me/919876095163?text=Hi%20BentoBox,%20I%20have%20an%20inquiry%20about%20a%20bulk%20order.', '_blank')}
                      className="w-full bg-white hover:bg-green-50 text-[#166534] border border-gray-200 py-3.5 rounded-xl font-semibold transition-colors flex items-center justify-center gap-2">
                      Need urgent help? <FaWhatsapp className="text-green-600 text-lg" /> <span className="text-green-700">WhatsApp us</span>
                    </button>
                  </div>

                  {/* Security Footer */}
                  <div className="pt-4 flex items-center justify-center gap-2 text-xs text-gray-500">
                    <FaLock /> Your information is 100% safe and secure with us.
                  </div>

                </form>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* FAQs */}
      <FAQsComponent preloadedData={bulkOrderFaqsData} compact={true} />

      {/* Testimonials */}
      <Body7 preloadedData={data?.body7} />

      {/* CTA */}
      <Body9 preloadedData={data?.body9} />
    </>
  );
};

const BulkOrder = () => {
  return (
    <BulkOrderDataProvider>
      <div className="font-sans">
        <SEO pageName="bulkorder" />
        <Navbar />
        <BulkOrderContent />
        <Footer />
      </div>
    </BulkOrderDataProvider>
  );
};

export default BulkOrder;
